import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const GradientBox = styled(Box)(() => ({
  background:
    'linear-gradient(93deg, rgba(100, 120, 182, 0.20) 41.92%, rgba(0, 183, 181, 0.20) 65.52%, rgba(0, 183, 181, 0.20) 81.34%, rgba(255, 255, 255, 0.20) 104.69%)',
  filter: 'blur(40px)',
  opacity: 0.5
}))
